import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

// GenerIA Brand Logo URL
const GENERIA_LOGO = "https://customer-assets.emergentagent.com/job_inspeccion-pwa/artifacts/qhvfjidw_IMG_8814.jpeg";

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('Bienvenido a GenerIA');
    } else {
      toast.error(result.error || 'Error al iniciar sesión');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="w-full max-w-md px-6">
        {/* Logo and Branding */}
        <div className="text-center mb-10">
          <img 
            src={GENERIA_LOGO} 
            alt="GenerIA" 
            className="w-64 h-64 object-contain mx-auto mb-4"
            data-testid="app-logo"
          />
        </div>

        {/* Login Form */}
        <div className="bg-[#0D1520] border border-[#1E3550] rounded-xl p-8">
          <form onSubmit={handleLogin} className="space-y-6" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-[#8BA3C7]">
                Correo Electrónico
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 h-12 bg-[#060C18] border-[#1E3550] text-[#E2EAF4] placeholder:text-[#4A6B8A] focus:border-[#0066FF] focus:ring-[#0066FF]"
                data-testid="email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-[#8BA3C7]">
                Contraseña
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 h-12 bg-[#060C18] border-[#1E3550] text-[#E2EAF4] placeholder:text-[#4A6B8A] focus:border-[#0066FF] focus:ring-[#0066FF]"
                data-testid="password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-[#0066FF] hover:bg-[#0052CC] text-white font-semibold text-base rounded-lg transition-colors"
              data-testid="login-submit-button"
            >
              {loading ? 'Iniciando sesión...' : 'INICIAR SESIÓN'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};
